import appStore from "@/store/modules/app.js";
import _ from "lodash";
import { systemCodeAppMap } from "@/utils/constant";
import NATIVE from "./native";
import dayjs from "dayjs";
/**
 * 千位分割
 * @param {number | string} num
 * @return {string}
 */
export function splitThousands(num) {
  if (!num && num !== 0) {
    return num;
  }
  const flag = parseFloat(num) < 0 ? "-" : "";
  let numStr = String(num);
  const end = numStr.split(".")[1] ? "." + numStr.split(".")[1] : "";
  const arr = [...String(Math.abs(parseInt(num)))];
  let result = "";
  while (arr.length > 3) {
    result = "," + arr.splice(-3).join("") + result;
  }
  return flag + arr.join("") + result + end;
}

/**
 * 生成uuid
 * @param {number} len 长度
 * @param {number} radix 基数(范围)
 * @return {string}
 */
export function getUuid(len, radix) {
  let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  const uuid = [];
  let i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}

/**
 * 8位日期格式化 20200508 => 2020-05-08
 * @param {number} date 日期
 * @return {string}
 */
export function numDateToDate(date) {
  if (!date) {
    return "-";
  }
  return date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2);
}

/**
 * 除了0 所有能转换为false的都用“-”代替
 * @param {number} val 目标值
 * @param {number} showValue  val格式化后的值
 * @return {string}
 */
export function emptyToLine(val, showValue = "") {
  return val || val === 0 ? showValue || val : "-";
}

/**
 * 拼接轮胎规格的回显文案，扁平比为 NA 时按空字符串展示
 * @param {string} tread 胎面宽度
 * @param {string} aspect 扁平比
 * @param {string} rim 轮辋
 * @return {string} 例：P205/55R17，扁平比为 NA 时回显为 P205/R17
 */
export function formatTireSize(tread, aspect, rim) {
  const aspectText = aspect === "NA" ? "" : aspect || "";
  return `${tread || ""}/${aspectText}R${rim || ""}`;
}

/**
 * 等待一段时间
 * sleep
 */
export const sleep = (delay = 1000, fn) => {
  return new Promise(function(resolve, reject) {
    setTimeout(() => {
      resolve(fn());
    }, delay);
  });
};

/**
 * 延迟
 * @param time 时长
 */
export const customSleep = function(time = 1000) {
  return new Promise(resolve => {
    const timer = setTimeout(() => {
      timer && clearTimeout(timer);
      resolve("");
    }, time);
  });
};

// 将数据转为map
export const expandArrayToMap = (list, { labelKey = "label", valueKey = "value" } = {}) => {
  let result = {};

  list.forEach(item => {
    let label = {};
    const value = item[valueKey];
    if (labelKey.split(",").length > 1) {
      labelKey.split(",").forEach(v => {
        label[v] = item[v];
      });
    } else {
      label = item[labelKey];
    }

    // value有可能是以逗号连接的多个值的组合
    if (value.indexOf(",") > -1) {
      value.split(",").forEach(key => (result[key] = label));
    } else {
      result[value] = label;
    }
  });

  return result;
};

export const keepTwoDecimal = num => {
  let result = parseFloat(num);
  if (isNaN(result)) {
    return false;
  }
  result = Math.round(num * 100) / 100;
  return result + "%";
};

// ————————————————————————————————————————————————————————————————————————————
// 获取平台
export const getPlatform = () => {
  if (
    navigator.userAgent.toLowerCase().indexOf("iphone") > -1 ||
    navigator.userAgent.toLowerCase().indexOf("ipad") > -1
  ) {
    return "iphone";
  } else if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
    return "aphone";
  }
  return "other";
};

// 如果app需要设置顶部 title
export const setWebviewTitle = title => {
  document.title = title;
};

// IOS手机点击输入框获取焦点
export const getFocus = event => {
  event.target.focus();
};

export const getMediaType = url => {
  const imageFormat = ["png", "jpg", "jpge", "ico", "bmp", "gif", "tif", "pcx", "tga"];
  const videoFormat = ["mp4", "avi", "mp4", "avi", "3gp", "rmvb", "wav", "mpg", "mkv", "vob", "mov", "flv", "swf"];
  let arr = url.split(".");
  let type = arr[arr.length - 1];
  if (imageFormat.includes(type.toLowerCase())) {
    return "image";
  } else if (videoFormat.includes(type.toLowerCase())) {
    return "video";
  } else {
    return new Error("not image or video file");
  }
};

export const getMediaTypeBase64 = base64 => {
  if (!base64) return "";
  return base64.split("/")[0].split(":")[1];
};

/**
 *根据域名获取国家地区
 * @returns Country flag
 */
export function getCountry() {
  const host = window.location.host;
  const reg = /speedbiz(\.|-|[0-9a-zA-Z])*(\.|-)my/;
  if (host === "speedbiz-h5.gtech.asia" || reg.test(host)) {
    return "my";
  } else {
    return "china";
    // return "my";
  }
}

/**
 * 加载地图，返回Promise
 */
export const loadGoogleMap = () => {
  return new Promise(resolve => {
    if (window.google) {
      resolve("");
      return;
    }
    let script = document.createElement("script");
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCHEEMsDEpExScEukSabhgvIV-oHSSRBKQ&libraries=places";
    script.onload = resolve;
    document.head.appendChild(script);
  });
};

/**
 *
 * @param money 金额
 * @param split 是否千位分割
 * @returns 结果
 */
export function addCurrencySymbol(money, split = false) {
  return moneyFormat(money, split);
}

/**
 *
 * @param money 金额
 * @param split 是否千位分割
 * @param hasBrackets 货币单位是否有括号，比如：收款金额(元)
 * @returns 结果
 */
export function addCurrencyUnit(money, split = false, hasBrackets = false) {
  console.log(split, hasBrackets);
  return money;
}

/**
 *国际化数字表示
 * @param value 要格式化的值
 * @param split 是否千位分割
 * @param symbol 是否显示货币符号 prefix
 * @param unit 是否显示货币单位 suffix
 * @param unitBrackets 货币单位是否用括号包裹 10.00(元)
 * symbol = false, unit = false, unitBrackets = false
 */
export function moneyFormat(value, split = false, symbol = false, unit = false, unitBrackets = false) {
  if (_.isNil(value)) {
    console.log(`${value} not Number or String Number ${symbol && unit && unitBrackets}`);
    return "";
  }
  const separator = appStore.state.separator || ",";
  const decimalPlaces = _.isNil(appStore.state.decimalPlaces) ? 2 : appStore.state.decimalPlaces;
  const valueNum = Number(value);
  return split ? splitThousands(valueNum.toFixed(decimalPlaces), separator) : valueNum.toFixed(decimalPlaces);
}

// 安全获取对象属性
export function safeValue(obj, keyStr, placeholder = "") {
  if (!obj) return placeholder;
  const keyArr = keyStr.split(".");
  let curValue = obj;
  for (let i = 0; i < keyArr.length; i++) {
    let temp = curValue[keyArr[i]];
    if (!temp) {
      console.warn(keyStr + " of undefined");
      return placeholder;
    }
    curValue = temp;
  }
  return curValue;
}

// 所在浏览器环境
export function getBrowserPlatform() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("micromessenger") !== -1) {
    return "wechat";
  } else {
    return "other";
  }
}

export function crossAppMsgJumper(msgData) {
  const appName = systemCodeAppMap[msgData.systemCode];
  const { site } = msgData;
  let siteUrl = "";
  if (site.includes("http://") || site.includes("https://")) {
    NATIVE.msgIntentExternalLink(site);
  } else {
    if (appName === "b2bcash") {
      siteUrl = `${window.B2B_CASH_SITE_URL}${site}`;
    } else if (appName === "b2bpoints") {
      siteUrl = `${window.B2B_POINTS_SITE_URL}${site}`;
    } else if (appName === "wintogether") {
      siteUrl = `${window.WINTOGETHER_SITE_URL}${site}`;
    }
    location.href = siteUrl;
  }
}

/**
 *  获取基于dayjs的日期或区间
 *  @param { String } dateKey  dateKey
 *  @param { String } format  dateKey
 *  @return { Date }
 */
export function getDateRange(dateKey, format) {
  const dateFunc = {
    yesterday_to_yesterday: () => {
      return [
        dayjs()
          .subtract(1, "day")
          .toDate(),
        dayjs()
          .subtract(1, "day")
          .toDate()
      ];
    },
    today_to_today: () => {
      return [dayjs().toDate(), dayjs().toDate()];
    },
    first_day_to_today_of_current_month: () => {
      return [
        dayjs()
          .startOf("month")
          .toDate(),
        dayjs().toDate()
      ];
    },
    first_day_to_yesterday_of_current_month: () => {
      if (dayjs().get("date") === 1) {
        return [
          dayjs()
            .subtract(1, "month")
            .startOf("month")
            .toDate(),
          dayjs()
            .subtract(1, "month")
            .endOf("month")
            .toDate()
        ];
      } else {
        return [
          dayjs()
            .startOf("month")
            .toDate(),
          dayjs()
            .subtract(1, "day")
            .toDate()
        ];
      }
    },
    current_month_to_current_month: () => {
      return [dayjs().toDate(), dayjs().toDate()];
    },
    first_month_to_current_month_of_current_year: () => {
      return [
        dayjs()
          .startOf("year")
          .toDate(),
        dayjs().toDate()
      ];
    },
    first_month_to_last_month_of_current_year: () => {
      if (dayjs().get("month") === 1) {
        return [
          dayjs()
            .subtract(1, "year")
            .startOf("year")
            .toDate(),
          dayjs()
            .subtract(1, "year")
            .endOf("year")
            .toDate()
        ];
      } else {
        return [
          dayjs()
            .startOf("year")
            .toDate(),
          dayjs()
            .subtract(1, "month")
            .endOf("month")
            .toDate()
        ];
      }
    }
  };
  if (format) {
    return dateFunc[dateKey]().map(date => dayjs(date).format(format));
  } else {
    return dateFunc[dateKey]();
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js